<template>
  <button
    class="cf-header-button cf-header-button--mobile-hidden"
    type="button"
    title="Sign Up"
    @click="handleButtonClick"
  >
    Sign Up
  </button>
</template>


<script>
  export default {
    name: 'CfSignUpButton',

    methods: {
      handleButtonClick() {
        this.$openModal('createAccount');
      }
    }
  };
</script>
